export default __webpack_public_path__ + "static/media/gosc_gada_pop.d54bd5bf.gif";